<template>
  <div>
    <div class="d-flex align-center">
      <div class="text-5 gray--text mr-5">02</div>
      <div class="heading-5 font-weight-medium">
        Connect Signer Wallet
      </div>
    </div>
    <div v-if="connectedSigner" class="mt-3">
      <div class="text-5">Use your connected wallet</div>
      <div class="d-flex align-center justify-space-between mt-2">
        <div
          class="flex-1 d-flex align-center border-primary rounded-50 pl-5"
          style="height:40px;"
        >
          <img
            :src="
              $vuetify.theme.dark
                ? walletMap[connectedSigner.type].logoDark ||
                  walletMap[connectedSigner.type].logo
                : walletMap[connectedSigner.type].logo
            "
            height="20px"
          />
          <span class="text-5 ml-3 primary--text">{{
            connectedSigner.address
          }}</span>
        </div>
        <v-checkbox
          v-model="checkboxExisting"
          hide-details
          class="mt-0 ml-3"
          @change="checkboxExisting && (checkboxNew = false)"
        ></v-checkbox>
      </div>
    </div>
    <div class="mt-5">
      <div class="text-5" v-if="connectedSigner">
        Or connect with
      </div>
      <div>
        <div
          class="d-flex flex-column flex-sm-row justify-sm-center flex-sm-wrap"
        >
          <div
            v-ripple
            v-for="item in walletsToSelect"
            :key="item.name"
            :class="[
              'rounded-10 d-flex flex-column align-center justify-center clickable mt-5 border-default ml-2 mr-2',
            ]"
            style="height:90px; width:90px;"
            @click="walletSelected = item"
          >
            <img
              :src="
                $vuetify.theme.dark ? item.logoDark || item.logo : item.logo
              "
              alt=""
              height="24px"
              width="24px"
            />
            <div class="mt-2 text-6">{{ item.text }}</div>
          </div>
        </div>
        <c-modal
          @onClosed="walletSelected = null"
          :value="!!walletSelected"
          :persistent="true"
          width="647"
        >
          <get-address
            :wallet="walletSelected"
            :project="projectSelected"
            @onAddressSelected="onAddressSelected"
            @onCancelled="walletSelected = null"
            @onError="onConnectError"
          />
        </c-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import WALLETS from "@/common/config/wallets";

export default {
  props: ["signerAddress"],
  components: {
    "get-address": () => import("../../wallet/GetAddress"),
  },
  computed: {
    ...mapGetters({
      walletList: "userWallets/walletList",
      projects: "projectConfig/projects",
    }),
    connectedSigner() {
      return this.walletList.result.find(
        w => w.address.toLowerCase() === this.signerAddress.toLowerCase()
      );
    },
    projectSelected() {
      return this.projects.find(pr => pr.name === "ethereum");
    },
    walletsToSelect() {
      return WALLETS.filter(
        w => w.active && w.projects.includes("ethereum") && w.name !== "gnosis"
      );
    },
    walletMap() {
      return this.walletsToSelect.reduce(
        (acc, cur) => ({ ...acc, [cur.name]: cur }),
        {}
      );
    },
  },
  data: () => ({
    checkboxExisting: false,
    checkboxNew: false,
    walletSelected: null,
  }),
  methods: {
    onAddressSelected(address, metadata) {
      const type = this.walletSelected.name;
      this.walletSelected = null;

      if (address.toLowerCase() !== this.signerAddress.toLowerCase()) {
        this.$store.dispatch("addAlert", {
          type: "error",
          title: "Error",
          message: `Please select the correct account.\nExpected address: ${this.signerAddress}.\nActual address: ${address}.`,
        });
        return;
      }
      this.$emit(
        "setSignerWallet",
        {
          type,
          address,
          metadata,
        },
        true
      );
    },
    onConnectError(error) {
      this.walletSelected = null;
      this.$store.dispatch("addAlert", {
        type: "error",
        title: "Error",
        message: error.message,
      });
    },
  },
  mounted() {
    if (this.connectedSigner) {
      this.checkboxExisting = true;
      this.$emit("setSignerWallet", this.connectedSigner);
    }
  },
};
</script>
